import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth"
  })}
      aria-label="Revenir en haut"
  className={`fixed bottom-[9rem] md:bottom-[5.5rem] right-4 md:right-6 z-40 md:z-50 p-3 rounded-full gradient-primary text-primary-foreground shadow-lg border border-cyan-glow/30 transition-all duration-300 hover:scale-110 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
  }`}
    >
      <ArrowUp size={20} />
    </button>
  );
}
